import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import AddCourierHub from "./AddCourierHub";
import { ConnContext } from "../../store/ConnContext";
import { useSelector } from "react-redux";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import AddCompanyImage from "../../../assets/Images/image 76.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";

// ✅ Main component
const AddCourierHubTabs = ({
  CloseCreate,
  show,
  editData,
  action,
  fetchCustomerData,
}) => {
  const { payloadData, setPayloadData } = useContext(ConnContext);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (action === "add") {
      // Reset form data for adding a new customer
      setPayloadData({
        username: loggedInUserName,
        name: "",
        emailId: "",
        address1: "",
        address2: "",
        address3: "",
        city: "",
        state: "",
        pinCode: "",
        firstContactPersonName: "",
        firstContactPersonMobileNo: "",
        gstNumber: "",
        aadharNumber: "",
        panNumber: "",
      });
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete" ||
      action === "auth"
    ) {
      // Pre-fill the form with editData
      setPayloadData({
        ...editData,
        name: editData?.hubName,
        emailId: editData?.hubEmailId,
        address1: editData?.addr1,
        address2: editData?.addr2,
        address3: editData?.addr3,
        city: editData?.city,
        state: editData?.state,
        pinCode: editData?.pinCode,
        firstContactPersonName: editData?.contactPersonName,
        firstContactPersonMobileNo: editData?.contactPersonMobileNo,
        gstNumber: editData?.gstNumber,
        aadharNumber: editData?.aadharNumber,
        panNumber: editData?.panNumber,
        username: loggedInUserName,
        bankName: editData?.bankName || "",
        hubCode: editData?.hubCode || "",
      });
    }
  }, [action, editData]);

  const loggedInUserName = user?.data?.username;

  const handleSubmit = async () => {
    const payloadForRate = {
      rate: payloadData?.rate,
      rcsRate: payloadData?.rcsRate,
      // Include emailId only when action is "add"
      ...(action === "add" && { emailId: payloadData?.emailId }),
    };

    try {
      const rateResponse = await axiosPostApi(
        apiList.RATE_CHECK,
        payloadForRate
      );
      const respCode = rateResponse?.data?.respCode;

      if (rateResponse?.data?.status && respCode === "00") {
        // Proceed to submit
        const submitPayload = { ...payloadData };
        const apiEndpoint =
          action === "add"
            ? apiList.CREATE_COURIER_HUB
            : apiList.UPDATE_COURIER_HUB;
        const submitResponse = await axiosPostApi(apiEndpoint, submitPayload);

        if (
          submitResponse?.data?.status &&
          submitResponse?.data?.respCode === "00"
        ) {
          CustomAlert({
            title: "Success",
            text: `${
              action === "add" ? "Courier Hub added" : "Courier Hub updated"
            } successfully`,
            icon: "success",
            confirmButtonText: "OK",
          });
          fetchCustomerData();
          CloseCreate();
        } else {
          CustomAlert({
            title: "Failed",
            text: submitResponse?.data?.message || "Submission failed",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } else if (respCode === "01") {
        CustomAlert({
          title: "Failed",
          text: rateResponse?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      } else {
        CustomAlert({
          title: "Failed",
          text: rateResponse?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while processing.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const getComponentByActiveStep = () => {
    return (
      <AddCourierHub
        payloadData={payloadData}
        setPayloadData={setPayloadData}
        loggedInUserName={loggedInUserName}
        CloseCreate={CloseCreate}
        editData={editData}
        action={action}
        fetchCustomerData={fetchCustomerData}
        handleSubmit={handleSubmit}
      />
    );
  };

  return (
    <>
      <div
        className={`modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content rounded-[23px]">
            <img
              src={LeftCircle}
              alt="leftImg"
              className="absolute left-0 bottom-0 w-[110px] h-[105px]"
            />
            <img
              src={RightCircle}
              alt="leftImg"
              className="absolute right-0 top-0 w-[110px] h-[105px]"
            />
            <div className="modal-header flex justify-between items-center border-b-0 !px-6">
              <div className="flex items-center gap-3">
                <img
                  src={AddCompanyImage}
                  alt="add-company-img"
                  className="h-11 w-11"
                />
                <h5 className="modal-title main-title m-0 font-semibold">
                  {action.charAt(0).toUpperCase() + action.slice(1)} Courier Hub
                  Details
                </h5>
              </div>
              <img
                src={CrossIcon}
                alt="filter icon"
                className="w-[30px] h-[30px] cursor-pointer z-20"
                onClick={CloseCreate}
              />
            </div>

            <Box sx={{ p: 3 }}>{getComponentByActiveStep()}</Box>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default AddCourierHubTabs;
